import { ActionConfig } from '@assembly-js/design-system';

export const EDITOR_ACTION_IDS = {
  HEADING2: 'heading2',
  HEADING3: 'heading3',
  TEXT: 'text',
  BOLD: 'bold',
  ITALIC: 'italic',
  UNDERLINE: 'underline',
  STRIKE: 'strike',
  BULLET_LIST: 'bulletList',
  ORDERED_LIST: 'orderedList',
} as const;

export const EDITOR_ACTIONS_CONFIG: ActionConfig[] = [
  {
    id: 'heading',
    type: 'group',
    label: 'Heading',
    actions: [
      {
        id: 'heading1',
        type: 'action',
        label: 'Heading 1',
        action: 'heading1',
        icon: 'H1',
      },
      {
        id: 'heading2',
        type: 'action',
        label: 'Heading 2',
        action: 'heading2',
        icon: 'H2',
      },
      {
        id: 'heading3',
        type: 'action',
        label: 'Heading 3',
        action: 'heading3',
        icon: 'H3',
      },
      {
        id: 'text',
        type: 'action',
        label: 'Text',
        action: 'text',
        icon: 'Text',
      },
    ],
  },
  {
    id: 'textStyle',
    type: 'group',
    label: 'Text Style',
    actions: [
      {
        id: 'bold',
        type: 'action',
        label: 'Bold',
        action: 'bold',
        icon: 'Bold',
      },
      {
        id: 'italic',
        type: 'action',
        label: 'Italic',
        action: 'italic',
        icon: 'Italicize',
      },
      {
        id: 'underline',
        type: 'action',
        label: 'Underline',
        action: 'underline',
        icon: 'Underline',
      },
      {
        id: 'strike',
        type: 'action',
        label: 'Strikethrough',
        action: 'strike',
        icon: 'Strikethrough',
      },
    ],
  },
  // list style actions
  {
    id: 'listStyle',
    type: 'group',
    label: 'List Style',
    actions: [
      {
        id: 'bulletList',
        type: 'action',
        label: 'Bullet List',
        action: 'bulletList',
        icon: 'UnorderedList',
      },
      {
        id: 'orderedList',
        type: 'action',
        label: 'Ordered List',
        action: 'orderedList',
        icon: 'NumberedList',
      },
    ],
  },
  {
    id: 'link',
    type: 'group',
    label: 'Link',
    actions: [
      {
        id: 'link',
        type: 'action',
        label: 'Add Link',
        action: 'link',
        icon: 'Link',
      },
      {
        id: 'attachFiles',
        type: 'action',
        label: 'Attach Files',
        action: 'attachFiles',
        icon: 'File',
      },
      {
        id: 'embed',
        type: 'action',
        label: 'Embed',
        action: 'embed',
        icon: 'Code',
      },
    ],
  },
];

export type EditorActionId =
  (typeof EDITOR_ACTION_IDS)[keyof typeof EDITOR_ACTION_IDS];
